<template>
    <div class="d-flex py-2 align-items-center">
        <b-pagination size="size" :total-rows="totalRows" :hide-ellipsis="true"
                      @change="onPageChange" :value="currentPage" :per-page="perPage.value">
        </b-pagination>
        <b-dropdown v-if="showPerPageOptions" variant="outline-primary">
            <template slot="button-content">
                <div class="d-inline-block">
                    <span>{{perPage.text}}</span>
                </div>
            </template>
            <b-dropdown-item @click="onPerPageChange(item)"
                             href="#" v-for="item in perPageOptions">{{item.text}}</b-dropdown-item>
        </b-dropdown>
    </div>
</template>
<script>
    import getters from '../../../utils/getters';

    export default {
        name: 'Pagination',
        props: {
            size: { type: String, default: 'md' },
            storePath: { type: String, required: true },
            showPerPageOptions: {type: Boolean, default: true}
        },
        data: function() {
            return {
                perPageOptions: [{value: 10, text: '10 per page'},
                    {value: 25, text: '25 per page'}, {value: 50, text: '50 per page'}],
            }
        },
        computed: {
            state() {
                return getters.getValueByPropertyName(this.$store.state, this.storePath, '/');
            },
            totalRows() {
                return this.state.itemsCount;
            },
            perPage() {
                return this.state.itemsPerPage;
            },
            currentPage() {
                return this.state.current;
            }
        },
        methods: {
            onPerPageChange: function(item) {
                this.$store.commit(this.storePath + '/setCurrentPage', 1);
                this.$store.commit(this.storePath + '/setPerPage', item);
                this.$emit('pageChanged', this.state);
            },
            onPageChange(page) {
                this.$store.commit(this.storePath + '/setCurrentPage', page);
                this.$emit('pageChanged', this.state);
            }
        }
    };
</script>
